import React, { forwardRef } from "react";
import TextInput from "../../text-input";
import { NameTypes } from "../types/name.types";

export interface CreditCardNameWithForwardRef
  extends React.ForwardRefExoticComponent<
    NameTypes & React.RefAttributes<HTMLInputElement>
  > {}

export const CreditCardName = forwardRef<HTMLInputElement, NameTypes>(
  (
    { label = "Name on card", ...props }: NameTypes,
    ref
  ): React.ReactElement => {
    return <TextInput label={label} {...props} ref={ref} />;
  }
) as CreditCardNameWithForwardRef;

CreditCardName.displayName = "CreditCardName";
